module.exports = __webpack_public_path__ + "static/media/avatar-C_K.aa29ac58.png";